import { loadable } from '../../common/utils/lazyLoading';
const MessagePortalWidget = loadable(() => import('./MessagePortalWidget'));
export default {
    id: 'message_portal',
    title: 'Message Portal',
    route: 'message_portal',
    navbarWidget: MessagePortalWidget,
    order: 3,
    permission: 'facilities.client_portal',
    widgetOrder: 4,
    isPermissionCheckSkipped: true,
};
